/**
 * @class MadnesTimer
 * @constructor
 */
import {
    madnes_time_event_add,
    madnes_time_event_loop,
    madnes_time_event_stop
} from "../../../framework/src/engine/madnes/madnes";

export function MadnesTimer() {
    /** @type {*} */
    this._timer;
};

/**
 * @param {Function} func
 * @param {number} time
 * @returns {MadnesTimer}
 */
MadnesTimer.prototype.add = function(func, time) {
    this._timer = madnes_time_event_add(func, time);
    return this;
};

/**
 * @param {Function} func
 * @param {number} time
 * @returns {MadnesTimer}
 */
MadnesTimer.prototype.loop = function(func, time) {
    this._timer = madnes_time_event_loop(func, time);
    
    return this;
};

/**
 * @returns {MadnesTimer}
 */
MadnesTimer.prototype.stop = function() {
    madnes_time_event_stop(this._timer);
    return this;
};